// TODO: delete when new customize UI enabled for everyone
import React, { Component, Fragment } from 'react';
import b from 'b_';
import { inject, observer } from 'mobx-react';
import { ConsoleCard, ConsoleField, ConsolePage } from '../ConsoleFragments';
import Button from '../Button';
import RegistrationNoticeEditModal, {
    createPropsForRegistrationNoticePreview,
    registerNoticeTooltipInfo
} from './RegistrationNoticeEditModal';
import CustomPagesStore from '../../stores/CustomPagesStore';
import SnackStore from '../../stores/SnackStore';
import PagePreview from '../PagePreview/PagePreview';
import BrowserLogin from '../Authentication/BrowserLogin';
import ConsoleStore from '../../stores/ConsoleStore';
import { ROLE_READ_ONLY } from '../../stores/Administrators/AdministratorModalStore';
import './RegistrationNotice.css';

const block = b.lock('RegistrationNotice');

class RegistrationNotice extends Component {
    static propTypes = {
        console: ConsoleStore.PropType.isRequired,
        customPages: CustomPagesStore.PropType.isRequired,
        snack: SnackStore.PropType.isRequired,
    };

    componentWillMount() {
        this.props.customPages.load()
            .catch((error) => error && this.props.snack.showError(`Failed to load. ${error.message}`));
    }

    openRegistrationNoticeModal = () => {
        const { registrationNotice } = this.props.customPages;
        registrationNotice.isModalOpen.open();
    };

    render() {
        const { console, customPages } = this.props;
        const { registrationNotice } = customPages;
        const readOnly = console.authority === ROLE_READ_ONLY.value;

        return <ConsolePage title="Customize UI - Registration Notice">
            <ConsoleCard className={block('Section')}>
                <div className={block('Header')}>
                    <span className={block('Caption')}>Registration Notice</span>
                    {!readOnly ? <Button
                        className={block('Edit')}
                        raised
                        primary
                        icon="edit"
                        onClick={this.openRegistrationNoticeModal}
                    >Edit</Button> : null}
                </div>
                <ConsoleField
                    className={block('EnabledStatus')}
                    titleClassName={block('Title')}
                    name="Registration Notice Status"
                    info={registerNoticeTooltipInfo}
                    infoPosition="bottom"
                >
                    <div className={block('StatusResult')}>
                        <b>{registrationNotice.enabled ? 'Enabled' : 'Disabled'}</b>
                        <span> - registration notice is {registrationNotice.enabled ? 'enabled' : 'disabled'}.</span>
                    </div>
                </ConsoleField>
                {registrationNotice.enabled ?
                    <Fragment>
                        <PagePreview
                            className={block('PagePreview')}
                            pageComponent={BrowserLogin}
                            previewToggle={registrationNotice.previewToggle}
                            headline="Registration Notice"
                            pageProps={createPropsForRegistrationNoticePreview(registrationNotice)}
                        />
                    </Fragment> : null}
            </ConsoleCard>
            <RegistrationNoticeEditModal />
        </ConsolePage>;
    }
}

export default inject('console', 'customPages', 'snack')(observer(RegistrationNotice));
